import { Zap } from "lucide-react"
import { cn } from "@/shared/lib/utils"
import { useAccesosRapidos } from "@/shared/context/AccesosRapidosContext"
import type { AccesoRapidoItem } from "@/shared/types/accesos-rapidos"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip"

interface QuickAccessButtonProps {
  item: AccesoRapidoItem
  className?: string
  variant?: "item" | "subitem"
}

export function QuickAccessButton({ item, className, variant = "item" }: QuickAccessButtonProps) {
  const { isAccesoRapido, toggleAccesoRapido, isLoading } = useAccesosRapidos()
  const isActive = isAccesoRapido(item.id)

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (!isLoading) {
      await toggleAccesoRapido(item)
    }
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={handleClick}
          disabled={isLoading}
          className={cn(
            "opacity-0 transition-opacity duration-200",
            variant === "item" ? "group-hover/menu-item:opacity-100" : "group-hover/sub-item:opacity-100",
            "absolute right-0 top-1/2 -translate-y-1/2 z-10",
            "p-0.5 rounded hover:bg-sidebar-accent",
            className
          )}
          aria-label={isActive ? "Quitar de accesos rapidos" : "Agregar a accesos rapidos"}
        >
          <Zap
            className={cn(
              "size-3.5 transition-colors text-gray-500",
              isActive && "fill-gray-500"
            )}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent side="right">
        {isActive ? "Quitar de accesos rapidos" : "Agregar a accesos rapidos"}
      </TooltipContent>
    </Tooltip>
  )
}
